export default "__VITE_ASSET__C74SFHZe__"